<template>
	<BaseModal id="game-select">
		<template #default="{close}">	
			<div class="modal modal--xxs modal--text-l">
				<div class="modal-close" @click="close"></div>
				<GameSelect/>
			</div>
		</template>
	</BaseModal>
</template>


<script>
import BaseModal from "@/components/utils/BaseModal.vue";
import GameSelect from "@/components/Popups/GameSelect.vue";
export default {
	name: "PopupGame",
	components: {
		GameSelect,
		BaseModal,
	},

}
</script>